import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import AllFees from './components/AllFees';

//Prueba
const Fees = ({ history, location }) => {
    useEffect(() => {
    }, []);
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Honorarios</h3>
                </Col>
            </Row>
            <Card>
                <CardBody>                    
                    <AllFees />
                </CardBody>
            </Card>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_fees',
})(Fees);